const AVATAR_STORAGE_KEY = 'mri_user_avatar'
const TARGET_SIZE = 96

export function loadSavedAvatar(): string | null {
    if (typeof window === 'undefined') return null
    try {
        return localStorage.getItem(AVATAR_STORAGE_KEY)
    } catch {
        return null
    }
}

export function saveUserAvatar(dataUrl: string): void {
    if (typeof window === 'undefined') return
    try {
        localStorage.setItem(AVATAR_STORAGE_KEY, dataUrl)
    } catch {
        // Nada
    }
}

export function removeUserAvatar(): void {
    if (typeof window === 'undefined') return
    try {
        localStorage.removeItem(AVATAR_STORAGE_KEY)
    } catch {
        // Nada
    }
}

/**
 * Processa qualquer formato de imagem (PNG, JPG, JPEG, WEBP, etc.)
 * e converte para um avatar quadrado ultra leve (~2KB) em WebP/JPEG.
 */
export async function processAvatarFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        if (!file.type.startsWith('image/')) {
            reject(new Error('Por favor, selecione um arquivo de imagem válido (PNG, JPG, WEBP).'))
            return
        }

        const reader = new FileReader()
        reader.onerror = () => reject(new Error('Erro ao ler a imagem selecionada.'))
        reader.onload = () => {
            const img = new Image()
            img.onerror = () => reject(new Error('Não foi possível carregar a imagem.'))
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas')
                    canvas.width = TARGET_SIZE
                    canvas.height = TARGET_SIZE
                    const ctx = canvas.getContext('2d')
                    if (!ctx) {
                        reject(new Error('Canvas 2D indisponível no navegador.'))
                        return
                    }

                    // Recorte centralizado quadrado perfeito
                    const minDim = Math.min(img.width, img.height)
                    const sx = (img.width - minDim) / 2
                    const sy = (img.height - minDim) / 2

                    // Suavização de alta qualidade
                    ctx.imageSmoothingEnabled = true
                    ctx.imageSmoothingQuality = 'high'
                    ctx.drawImage(img, sx, sy, minDim, minDim, 0, 0, TARGET_SIZE, TARGET_SIZE)

                    // Converte para WebP (ou JPEG se não suportado)
                    let dataUrl = canvas.toDataURL('image/webp', 0.82)
                    if (!dataUrl.startsWith('data:image/webp')) {
                        dataUrl = canvas.toDataURL('image/jpeg', 0.82)
                    }

                    resolve(dataUrl)
                } catch (err) {
                    reject(err instanceof Error ? err : new Error('Erro ao processar avatar.'))
                }
            }
            img.src = reader.result as string
        }
        reader.readAsDataURL(file)
    })
}
